import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@app/environment/environment';
import { Role } from '@app/models/admin.model';
import {
  AuthenticationResponse,
  LoginAsCompanyRequest,
  RefreshTokenRequest,
  UserLoginRequest,
  UserLoginRequest2fa,
} from '@app/models/auth.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private readonly API_URL = environment.apiUrl;

  login(payload: UserLoginRequest): Observable<AuthenticationResponse> {
    return this.http.post<AuthenticationResponse>(
      `${this.API_URL}/Auth/Login`,
      payload
    );
  }

  loginWith2fa(
    payload: UserLoginRequest2fa
  ): Observable<AuthenticationResponse> {
    return this.http.post<AuthenticationResponse>(
      `${this.API_URL}/Auth/Login2fa`,
      payload
    );
  }

  loginAsCompany(
    payload: LoginAsCompanyRequest
  ): Observable<AuthenticationResponse> {
    return this.http.post<AuthenticationResponse>(
      `${this.API_URL}/Auth/LoginAsCompany`,
      payload
    );
  }

  logoutFromCompany(): Observable<AuthenticationResponse> {
    return this.http.post<AuthenticationResponse>(
      `${this.API_URL}/Auth/LogoutFromCompany`,
      null
    );
  }

  refreshToken(): Observable<AuthenticationResponse> {
    return this.http.post<AuthenticationResponse>(
      `${this.API_URL}/Auth/Refresh`,
      null,
      { withCredentials: true }
    );
  }

  getRoles(): Observable<Role[]> {
    return this.http.get<Role[]>(`${this.API_URL}/Auth/Roles`);
  }

  logout(): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/Auth/Logout`, {});
  }

  logoutAll(): Observable<any> {
    return this.http.post<any>(`${this.API_URL}/Auth/Logout/All`, {});
  }
}
